/**
 * @file The Component to generate Navigation Sidebar
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import React from 'react';
import 'antd/dist/antd.css';
import { Steps } from 'antd';
import { pageObjects as winPageObjects } from '../../Utils/WindowsDataLoader';
import { pageObjects as linPageObjects } from '../../Utils/LinuxDataLoader';
import { LINUX, WINDOWS } from '../../Utils/Constants';
// import classes from './Navigation.module.css'
import './Navigation.css';

const { Step } = Steps;

/**
 * Jump to a specific page when a sidebar node is clicked
 * by changing the 'steps' state.
 * @param {Number} curSteps the step number that the clicked sidebar node represent for
 * @param {Object} props an Object that contains function and variable to get and set the states
 */
const onChangeSideBar = (curSteps, props) => {
    if (props.validateForm !== undefined) {
        props.validateForm((err, value) => {
            if (!err) {
                if (curSteps <= props.deepestStep) {
                    props.setOriginState('steps', curSteps);
                }
            }
        });
    } else {
        if (curSteps <= props.deepestStep) {
            props.setOriginState('steps', curSteps);
        }
    }
};

/**
 * Dynamically set the status style of each sidebar node
 * @param {Number} stepNumber the step number of current sidebar node
 * @param {Object} props   an Object that contains function and variable to get and set the states
 */
const setCurrentStepStatus = (stepNumber, props) => {
    return props.steps === stepNumber
        ? 'process'
        : props.deepestStep > stepNumber
        ? 'finish'
        : 'wait';
};

/**
 * Generate a sidebar JSX corresponding to the
 * pages that need to be displayed
 * @param {Object} pageObjects object that contains information for each page
 * @param {Object} props an Object that contains function and variable to get and set the states
 * @return {Object} JSX Object that can be rendered as a sidebar
 */
const initiateSideBar = (pageObjects, props) => {
    let count = 0;
    let stepList = pageObjects.map((page) => {
        let res = null;
        let hasPage = false; // whether to put the in the steps
        let dependStates = page.dependOnState;

        //the page should be displayed if it has no dependent product or any of its dependent product is chosen
        if (dependStates.length === 0) {
            hasPage = true;
        } else {
            for (let i = 0; i < dependStates.length; i++) {
                if (dependStates[i].startsWith('!')) {
                    // if the state is false, then display the page
                    let stateString = dependStates[i].substring(1).trim();
                    if (!props.getOriginState(stateString)) {
                        hasPage = true;
                        break;
                    }
                } else {
                    // if the state is true, then display the page
                    if (props.getOriginState(dependStates[i])) {
                        hasPage = true;
                        break;
                    }
                }
            }
        }

        if (hasPage) {
            res = (
                <Step
                    key={page.id}
                    title={page.sidebarLabel}
                    status={setCurrentStepStatus(count, props)}
                />
            );
            count++;
        }
        return res;
    });
    return (
        <Steps
            current={props.steps}
            onChange={(cur) => onChangeSideBar(cur, props)} //when a node is clicked
            direction="vertical"
            size="small"
        >
            {stepList}
        </Steps>
    );
};

const Navigation = (props) => {
    let pageObjects = null;

    switch (props.useOs) {
        case LINUX:
            pageObjects = linPageObjects;
            break;
        case WINDOWS:
            pageObjects = winPageObjects;
            break;
        default:
    }

    return initiateSideBar(pageObjects, props);
};

export default Navigation;
